var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"staff"},[_c('h2',[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"staff-container"},_vm._l((_vm.staff),function(member,key){return _c('StaffCard',{key:key,attrs:{"member":member,"showEmail":_vm.showEmail}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }